export default "__VITE_ASSET__BV7isvLz__"